import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/')({
  beforeLoad: () => {
    throw redirect({ to: '/clearing/operations/reporting/archive' });
  },
  preload: false,
});
